<template>
    <el-dialog width="400px" v-model="dialogVisible" :close-on-click-modal="true" :before-close="cancledialog" draggable
        :show-close="false">
        <el-form :model="form" label-position="right" v-loading="loading">
            <el-row :gutter="10" style="margin-bottom: 20px;">
                <el-col :span="24">
                    <div :class="form.posSide === constants.SHORT ? 'title red' : 'title green'">{{ title }}</div>
                </el-col>
            </el-row>
            <el-row :gutter="10" style="margin-bottom: 20px;">
                <el-col :span="24">
                    <el-alert :title="'开仓均价  ' + form.avgPx1" type="warning" :closable="false" />
                </el-col>
            </el-row>
            <el-row :gutter="10">
                <el-col :span="24">
                    <el-form-item label="止盈" label-width="70px">
                        <el-input class="price" v-model="form.tpTriggerPx">
                            <template #append>
                                <el-select v-model="form.tpTriggerPxType" placeholder="请选择" style="width:100px">
                                    <el-option label="标记价格" :value="constants.MARK"></el-option>
                                    <el-option label="最新价格" :value="constants.LAST"></el-option>
                                    <el-option label="指数价格" :value="constants.INDEX"></el-option>
                                </el-select>
                            </template>
                        </el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <div class="note">
                当最新价格到达<span>{{ form.tpTriggerPx }}</span>时，将会触发市价止盈委托平仓当前仓位。<br>
                预计盈亏为&nbsp;<span v-html="expectedTakeProfit"></span>&nbsp;USDT
            </div>
            <el-row :gutter="10">
                <el-col :span="24">
                    <el-form-item label="止损" label-width="70px">
                        <el-input class="price" v-model="form.slTriggerPx">
                            <template #append>
                                <el-select v-model="form.slTriggerPxType" placeholder="请选择" style="width:100px">
                                    <el-option label="标记价格" :value="constants.MARK"></el-option>
                                    <el-option label="最新价格" :value="constants.LAST"></el-option>
                                    <el-option label="指数价格" :value="constants.INDEX"></el-option>
                                </el-select>
                            </template>
                        </el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <div class="note">
                当最新价格到达<span>{{ form.slTriggerPx }}</span>时，将会触发市价止损委托平仓当前仓位。<br>
                预计盈亏为&nbsp;<span v-html="expectedStopMarket"></span>&nbsp;USDT
            </div>
        </el-form>
        <template #footer>
            <div class="dialog-footer">
                <el-button type="info" plain @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" plain @click="submit()" :disabled="loading">保 存</el-button>
            </div>
        </template>
    </el-dialog>
</template>

<style scoped>
.title {
    font-size: 18px;
    font-weight: bold;
}

.green {
    color: #67c23a;
}

.red {
    color: #f56c6c;
}

.entryPrice {
    border-radius: 5px;
    color: #555657;
    background: #cabe75;
    padding: 10px;
    margin-bottom: 10px;
    font-size: 14px;
}

.note {
    border-radius: 5px;
    color: #909399;
    background: #202121;
    padding: 10px;
    margin-bottom: 20px;
    font-size: 12px;
}
</style>

<script setup>
import { ref, toRaw, computed } from 'vue'
import { ElMessage } from 'element-plus'
import Decimal from 'decimal.js'
import * as constants from '@/utils/okxConstants'
import { useSystemStore } from '@/stores/system'
import { useLogStore } from '@/stores/log'
import Database from '@/service/database'

const emit = defineEmits(["callStopProfit"])
const systemStore = useSystemStore()
const logStore = useLogStore()
const dialogVisible = ref(false)
const loading = ref(false)
const title = ref("")
const form = ref({
    avgPx: "",
})

const expectedTakeProfit = computed(() => {
    if (!form.value.tpTriggerPx) return "--"
    let diff = 0
    if (form.value.posSide === constants.LONG) {
        diff = parseFloat(form.value.tpTriggerPx) - parseFloat(form.value.avgPx)
    } else {
        diff = parseFloat(form.value.avgPx) - parseFloat(form.value.tpTriggerPx)
    }
    diff = diff * parseFloat(form.value.availPos) * parseFloat(form.value.ctVal)
    diff = new Decimal(diff).toDecimalPlaces(2, Decimal.ROUND_FLOOR).toNumber()
    return diff > 0 ? `<span style="color:#67c23a">+${diff}</span>` : `<span style="color:#ff707e">${diff}</span>`
})

const expectedStopMarket = computed(() => {
    if (!form.value.slTriggerPx) return "--"
    let diff = 0
    if (form.value.posSide === constants.LONG) {
        diff = parseFloat(form.value.slTriggerPx) - parseFloat(form.value.avgPx)
    } else {
        diff = parseFloat(form.value.avgPx) - parseFloat(form.value.slTriggerPx)
    }
    diff = diff * parseFloat(form.value.availPos) * parseFloat(form.value.ctVal)
    diff = new Decimal(diff).toDecimalPlaces(2, Decimal.ROUND_FLOOR).toNumber()
    return diff > 0 ? `<span style="color:#67c23a">+${diff}</span>` : `<span style="color:#ff707e">${diff}</span>`
})

const init = async (data) => {
    dialogVisible.value = true

    let workingTypes = await Database.select('WorkingType')
    let tpWorkingType = workingTypes.find(x => x.Name == 'TP' && x.Platform == 'OKX')?.Type || constants.LAST
    let slWorkingType = workingTypes.find(x => x.Name == 'SL' && x.Platform == 'OKX')?.Type || constants.LAST

    //标题
    title.value = `${data.instId.replace(/-SWAP|-/g, "")} ${data.instType} ${(data.posSide === constants.LONG ? '多' : '空')} ×${data.lever}`

    //合约面值
    let symbol = systemStore.usymbols.find(x => x.symbol === data.instId)
    let _orderAlgo = data.closeOrderAlgo[0]

    //获取止盈止损设置
    form.value = data
    form.value.ctVal = symbol.info.ctVal
    form.value.algoId = ""
    form.value.tpTriggerPx = ""
    form.value.tpTriggerPxType = tpWorkingType
    form.value.slTriggerPx = ""
    form.value.slTriggerPxType = slWorkingType

    if (!_orderAlgo) return

    //有设置止盈或者止损
    form.value.algoId = _orderAlgo.algoId

    //有止盈
    if (Number(_orderAlgo.tpTriggerPx) > 0) {
        form.value.tpTriggerPx = Number(_orderAlgo.tpTriggerPx)
        form.value.tpTriggerPxType = _orderAlgo.tpTriggerPxType
    }

    //有止损
    if (Number(_orderAlgo.slTriggerPx) > 0) {
        form.value.slTriggerPx = Number(_orderAlgo.slTriggerPx)
        form.value.slTriggerPxType = _orderAlgo.slTriggerPxType
    }
}

const cancledialog = () => {
    dialogVisible.value = false
    form.value = { avgPx: "" }
}

const submit = async () => {
    if (!form.value.tpTriggerPx && !form.value.slTriggerPx) return

    try {
        loading.value = true
        if (form.value.algoId) {
            //修改
            let ordType = constants.CONDITIONAL
            if (form.value.tpTriggerPx && form.value.slTriggerPx) ordType = constants.OCO

            let _obj = {
                instId: form.value.instId,
                algoId: form.value.algoId,
                newTpOrdKind: ordType,
                newTpOrdPx: -1,
                newTpTriggerPx: form.value.tpTriggerPx || "0",
                newTpTriggerPxType: form.value.tpTriggerPxType,
                newSlOrdPx: -1,
                newSlTriggerPx: form.value.slTriggerPx || "0",
                newSlTriggerPxType: form.value.slTriggerPxType,
            }
            
            await systemStore.privateClient.amendAlgo(_obj)
            ElMessage.success('保存成功')
        } else {

            let ordType = constants.CONDITIONAL
            if (form.value.tpTriggerPx && form.value.slTriggerPx) ordType = constants.OCO

            let _obj = {
                instId: form.value.instId,
                tdMode: form.value.mgnMode,
                side: form.value.posSide === constants.LONG ? constants.SELL : constants.BUY,
                posSide: form.value.posSide,
                ordType: ordType,
                closeFraction: "1",
            }

            if (form.value.tpTriggerPx) {
                _obj.tpOrdPx = "-1"
                _obj.tpTriggerPx = form.value.tpTriggerPx
                _obj.tpTriggerPxType = form.value.tpTriggerPxType
            }

            if (form.value.slTriggerPx) {
                _obj.slOrdPx = "-1"
                _obj.slTriggerPx = form.value.slTriggerPx
                _obj.slTriggerPxType = form.value.slTriggerPxType
            }

            await systemStore.privateClient.orderAlgo(_obj)
            ElMessage.success('保存成功')
        }
        loading.value = false
        dialogVisible.value = false
    } catch (error) {
        loading.value = false
        ElMessage.error('保存失败' + error)
        logStore.addLog({
            title: '保存止盈止损失败',
            level: 'error',
            message: error
        })
    }
}

defineExpose({ init })

</script>
